import { Component, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { NgxImageCompressService } from 'ngx-image-compress';

@Component({
  selector: 'ngx-absensi-luar-dialog',
  templateUrl: './absensi-luar-dialog.component.html',
  styleUrls: ['./absensi-luar-dialog.component.scss'],
})
export class AbsensiLuarDialogComponent implements OnInit {
  timeOut = 10000;
  countDown = 10;
  myInterval;
  absenForm: UntypedFormGroup;
  imageUrl: any;

  constructor(
    protected ref: NbDialogRef<AbsensiLuarDialogComponent>,
    private imageCompress: NgxImageCompressService
  ) {
    this.absenForm = new UntypedFormGroup({
      lokasi: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      keterangan: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
      file: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });
  }

  ngOnInit(): void {}

  closeOnTimeOut(timeLeft) {
    if (timeLeft <= 0) {
      this.close();
    }
    return;
  }

  close() {
    this.ref.close({ event: false });
    clearInterval(this.myInterval);
  }

  proceed() {
    let data = {
      lokasi: this.absenForm.get('lokasi').value,
      keterangan: this.absenForm.get('keterangan').value,
      file: this.imageUrl,
    };

    this.ref.close({ event: true, data: data });
  }

  async onSelectFile(event) {
    let files = event.target.files;
    if (files && files[0]) {
      if (this.bytesToSize(files[0].size) > 1024) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          let originaImg = event.target.result;
          this.imageCompress.compressFile(originaImg, 0, 50, 50).then((val) => {
            this.imageUrl = val;
          });
        };
        reader.readAsDataURL(files[0]);
      } else {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          let originaImg = event.target.result;
          this.imageUrl = originaImg;
        };
        reader.readAsDataURL(files[0]);
      }
    }
  }

  bytesToSize(bytes) {
    return Math.round(bytes / 1024);
  }
}
